var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, CloseIcon, Flex, Icon, InfoOutlineIcon, Text } from 'shared/components/ui';
export var ToastErrorBox = function (_a) {
    var title = _a.title, _b = _a.message, message = _b === void 0 ? '' : _b, _c = _a.onClose, onClose = _c === void 0 ? function () {
        return;
    } : _c, _d = _a.action, action = _d === void 0 ? null : _d, _e = _a.variant, variant = _e === void 0 ? 'error' : _e;
    return (_jsx(_Fragment, { children: _jsxs(Box, __assign({ justifyContent: "space-between", display: "flex", rounded: "md", color: "".concat(variant, ".text"), bgColor: "".concat(variant, ".light"), pb: "3" }, { children: [_jsxs(Box, __assign({ display: "flex" }, { children: [_jsx(Icon, { fontWeight: "bold", ml: "3.5", mt: "3.5", mr: "16px", fontSize: "xl", as: InfoOutlineIcon }), _jsxs(Flex, __assign({ mr: "16px", direction: "column", alignItems: "flex-start" }, { children: [_jsx(Text, __assign({ fontWeight: "bold", mt: "18px" }, { children: title })), _jsx(Text, __assign({ "data-testid": "validationErrors" }, { children: message })), action] }))] })), _jsx(Icon, { mr: "3.5", mt: "3.5", onClick: function () { return onClose(); }, fontSize: "sm", as: CloseIcon })] })) }));
};
